(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.addtoany = {
    attach: function (context, settings) {
      $(once('addtoany_share_native', '.addtoany_share_native')).each(function () {
        $(this).click(function () {
          if (navigator.share) {
            navigator.share({
              title: document.title,
              text: document.title,
              url: window.location.href
            });
          }
        });
      });
      $(once('addtoany_share', '.addtoany_share')).each(function () {
        $(this).click(function () {
          // Process menu.
          Drupal.behaviors.addtoany.processMenu($(this));
        });
      });
    },
    isDesktop: function () {
      return ($('body').width() >= 1025);
    },
    processMenu: function ($share_menu) {
      if (Drupal.behaviors.addtoany.isDesktop()) {
        var $buttons = [];

        // Get the share buttons.
        $(".addtoany_list a[class^='a2a_button_']").each(function () {
          $(this).find("span[class*='a2a_s__default']").each(function () {
            $buttons.push($(this).attr('class'));
          });
        });

        // Remove any menu items that match a button for desktop.
        $('.a2a_mini_services').each(function () {
          var $menu = $(this);
          $menu.children('.a2a_i').each(function () {
            var $menu_item = $(this);
            var $class = $menu_item.find('span').attr('class');

            if ($.inArray($class, $buttons) !== -1) {
              $menu_item.addClass('share-hidden');
            }
          });
        });
      }
      else {
        // Show all menu items for mobile.
        $('.a2a_mini_services').each(function () {
          $(this).children('.a2a_i').each(function () {
            $(this).removeClass('share-hidden');
          });
        });
      }
    }
  };
})(jQuery, Drupal, once);
